import { render, staticRenderFns } from "./poiDialog.vue?vue&type=template&id=3715a0ff&"
import script from "./poiDialog.vue?vue&type=script&lang=js&"
export * from "./poiDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports